import { AlertTriangle, LogOut } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { Button } from '@/ui/Button';

/**
 * What a seller sees while the shop they sell in has an expired subscription.
 * Only the shop's admin can renew, so there is nothing to do here but wait or
 * sign out; the API refuses every seller route until the shop is renewed.
 */
export function StorePausedScreen() {
  const { user, logout } = useAuth();

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-surface p-8 text-center shadow-card">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-danger/10 text-danger">
          <AlertTriangle className="h-6 w-6" aria-hidden="true" />
        </span>
        <h1 className="mt-4 font-display text-xl font-bold text-content">This store is paused</h1>
        <p className="mt-2 text-sm text-content-muted">
          The store&apos;s subscription has expired, so the seller dashboard is closed until the
          store owner renews it. Your products and orders are safe and will be back as soon as
          they do.
        </p>
        {user?.email && (
          <p className="mt-4 text-xs text-content-muted">
            Signed in as <strong className="text-content">{user.email}</strong>
          </p>
        )}
        <Button variant="secondary" className="mt-6" onClick={logout}>
          <LogOut className="h-4 w-4" aria-hidden="true" />
          Sign out
        </Button>
      </div>
    </main>
  );
}
